module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('applicants.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', [_vm._v(_vm._s(items.item.nombres) + " " + _vm._s(items.item.primer_apellido) + " " + _vm._s(items.item.segundo_apellido))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.tipo_documento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.departamento_nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.provincia_nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.municipio_nombre))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480718a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/solicitante/Solicitante.vue
// module id = 516
// module chunks = 2